import { useAppStore } from '@/store'

// Modelled on Tower's LoadingOverlay, with Diriyah's logo-fill treatment kept:
// the mark wipes left to right as the model streams, which reads as progress on
// a phone where a 1.5px bar does not.
export function LoadingOverlay() {
  const loaded = useAppStore((s) => s.loaded)
  const progress = useAppStore((s) => s.progress)

  if (loaded) return null

  return (
    <div className="bg-background fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 transition-opacity duration-500">
      <div className="relative h-10 w-auto">
        <img src="/logo.svg" alt="Augmento" className="h-10 w-auto opacity-20" />
        <div
          className="absolute inset-0 overflow-hidden transition-[clip-path] duration-200"
          style={{ clipPath: `inset(0 ${100 - progress}% 0 0)` }}
        >
          <img src="/logo.svg" alt="" aria-hidden className="h-10 w-auto" />
        </div>
      </div>
      <span className="text-muted-foreground text-xs tabular-nums">{progress}%</span>
    </div>
  )
}
